import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, switchMap } from 'rxjs/operators';

const GEOJSON_API = environment.geoJsonApi;
// const API_URL = "http://localhost:4600/api/";
const API_URL = environment.apiUrl;
const bannedStateList = environment.bannedStateList;

@Injectable({
  providedIn: 'root'
})
export class GeoLocationService {

  public isPaidContestBanned = new BehaviorSubject(false);
  public bannedStateList$: any;

  constructor(private http: HttpClient) {}

  getGeoLocation(): Observable<any> {
    return this.http.get(GEOJSON_API);

  }

  fetchAndSetGeoLocation(): void {
    this.http.get(API_URL + "bannedStateList").pipe(
      switchMap((data: any) => {
        this.bannedStateList$ = data;
        return this.getGeoLocation(); // Call getGeoLocation after setting bannedStateList$
      })
    ).subscribe({
      next: (data) => {
        this.isPaidContestBanned.next(this.bannedStateList$.includes(data.region));
      },
      error: (error) => {
        console.error('Failed to fetch data:', error);
      }
    });
  }
}
